import { State } from 'modules';
import { EnterpriseModel } from 'types/models';
import { getMe } from './members';

export const isLoading = (state: State) => state.models.enterprises.isLoading;

export const getEnterpriseById = (
  state: State,
  idEnterprise: string,
): EnterpriseModel | undefined =>
  state.models.enterprises.collection[idEnterprise];

export const getMyEnterprises = (state: State): EnterpriseModel[] => {
  const me = getMe(state);
  if (me && me.enterprises) {
    return me.enterprises;
  }

  return [];
};

export const getAdminEnterprises = (state: State): EnterpriseModel[] => {
  const me = getMe(state);
  if (!me) {
    return [];
  }
  const { idEnterprisesAdmin = [] } = me;

  return idEnterprisesAdmin
    .map((id) => getEnterpriseById(state, id))
    .filter((enterprise) => !!enterprise) as EnterpriseModel[];
};

export const hasEnterprises = (state: State): boolean => {
  const enterprises = getMyEnterprises(state);

  return !!enterprises && !!enterprises.length;
};

export const isEnterpriseAdmin = (state: State): boolean => {
  const me = getMe(state);

  return !!(
    me &&
    me.confirmed &&
    me.idEnterprisesAdmin &&
    me.idEnterprisesAdmin.length > 0
  );
};



// WEBPACK FOOTER //
// ./app/gamma/src/selectors/enterprises.ts